import { render, staticRenderFns } from "./GptVoicePanel.vue?vue&type=template&id=89943030"
import script from "./GptVoicePanel.vue?vue&type=script&lang=js"
export * from "./GptVoicePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports